//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'AgencyExcursionSchedules',
  components: {
    Icon24FillPlus: () => import('@/assets/icons/Icon24FillPlus.svg?inline'),
    RoundButton: () => import('@/components/common/RoundButton'),
    AgencySchedulesCard: () => import('@/components/common/AgencySchedulesCard')
  },
  layout: 'personal-area-agency',
  data () {
    return {
      titles: [
        this.$t('components.agency-excursion-schedules.title-name'),
        this.$t('components.agency-excursion-schedules.title-started-at'),
        this.$t('components.agency-excursion-schedules.title-stopped-at'),
        this.$t('components.agency-excursion-schedules.title-time')
        // this.$t('components.agency-excursion-schedules.title-status'),
      ]
    }
  },
  computed: {
    ...mapGetters({
      schedules: 'account-agency-excursion/schedules'
    })
  },
  created () {
    this.$store.dispatch('account-agency-excursion/schedules', {
      id: this.$route.params.excursion_id,
      clear: true,
      params: {
        count: 30
      }
    })
  },
  methods: {
    openPopupAddSchedule () {
      this.$store.commit('popup/open', {
        name: 'PopupAddSchedule',
        params: {
          style: {
            width: '632px',
            maxHeight: '100vh'
          }
        }
      })
    }
  }
}
